export interface ICoordinates {
  lat: number;
  lng: number;
}
